import FormIndex from './FormIndex';
import FormCreate from './FormCreate';
import FormSettings from './FormSettings';
import FormSingle from './FormSingle';

export default function (app) {

    const settings = FormSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    FormIndex(app, settings);

    FormCreate(app, settings);

    FormSingle(app, settings);

}